import { FreeGameButtonControllerBehavior } from "@quest/murka-games-behavior-leopard";
import { View } from "./View";
import { FreeGameModel } from "../model/FreeGameModel";
import { gameConstants } from "../Constants/gameConstants";

export class FreeGameButtonControllerGame extends FreeGameButtonControllerBehavior{
    constructor(view: View, model: FreeGameModel) {
        super(view, model);
        this.view = view;
        this.handleButtonPanelBGAlpha();
      }
    /**
     * temporarily created as image does not have alpha support from json
     * will remove this code and add the alpha support in view
     */
    private handleButtonPanelBGAlpha(): void {
        this.view.getImageById("Button_Panel_Base") && (this.view.getImageById("Button_Panel_Base").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA)
        this.view.getImageById("portraitButtonBG") && (this.view.getImageById("portraitButtonBG").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA)
        this.view.getImageById("Button_Panel_BasePort") && (this.view.getImageById("Button_Panel_BasePort").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA)
    }

}